export const RIDER_PROFILE_TAB_SUB_PERMISSIONS = {
  overview: "view_rider_overview",
  statusHistory: "view_rider_status_history",
  documents: "view_rider_documents",
  orders: "view_rider_orders",
  earnings: "view_rider_earnings",
  payments: "view_rider_payments",
  ratings: "view_rider_ratings",
  location: "view_rider_location",
}

export const RIDER_PROFILE_TAB_ORDER = [
  "overview",
  "statusHistory",
  "documents",
  "orders",
  "earnings",
  "payments",
  "ratings",
  "location",
]

const hasSubPermissionCatalog = subPermissions =>
  subPermissions &&
  typeof subPermissions === "object" &&
  !Array.isArray(subPermissions)

const requiresLegacyPermission = (tabId, legacyPermissions = {}) => {
  switch (tabId) {
    case "earnings":
      return Boolean(legacyPermissions.earnings)
    case "payments":
      return Boolean(legacyPermissions.earnings || legacyPermissions.bank)
    case "location":
      return Boolean(legacyPermissions.location)
    case "documents":
      return Boolean(legacyPermissions.documents)
    default:
      return true
  }
}

const isSubPermissionEnabled = (subPermissions, subPermissionId) => {
  if (!subPermissionId) {
    return true
  }

  const subPermission = subPermissions[subPermissionId]
  if (subPermission && typeof subPermission.isEnabled === "boolean") {
    return subPermission.isEnabled
  }

  const hasConfiguredSubPermissions = Object.values(
    RIDER_PROFILE_TAB_SUB_PERMISSIONS
  ).some(id => subPermissions[id] !== undefined)

  return !hasConfiguredSubPermissions
}

export const canViewRiderProfileTab = ({
  hasView = false,
  subPermissions,
  tabId,
  legacyPermissions = {},
}) => {
  if (!hasView) {
    return false
  }

  if (!requiresLegacyPermission(tabId, legacyPermissions)) {
    return false
  }

  if (!hasSubPermissionCatalog(subPermissions)) {
    return true
  }

  const subPermissionId = RIDER_PROFILE_TAB_SUB_PERMISSIONS[tabId]
  return isSubPermissionEnabled(subPermissions, subPermissionId)
}

export const getFirstAllowedRiderProfileTab = ({
  hasView,
  subPermissions,
  legacyPermissions = {},
}) => {
  const allowedTab = RIDER_PROFILE_TAB_ORDER.find(tabId =>
    canViewRiderProfileTab({
      hasView,
      subPermissions,
      tabId,
      legacyPermissions,
    })
  )
  return allowedTab || "overview"
}
